import { CartService } from '@/services';
import { networkStatus } from '@/constants/networkStatus';
import {
  SET_CART_ARTICLES,
  SET_CART_SERVICES,
  SET_SERVICE_CENTER,
  SET_CART_ID,
  SET_SOURCE_ID,
  SET_INVOICE_ADDRESS,
  ADD_ARTICLE_VERSION_A,
  UPDATE_ARTICLE_VERSION_A,
  // SET_ALLOW_CHANGE_ADDRESS_FOR_SOURCE,
} from '../mutationTypes';

const state = {
  cartArticles: [],
  cartServices: [],
  serviceCenter: [],
  cartId: null,
  sourceId: null,
  invoiceAddress: {},
  articlesVersionA: [],
  // allowChangeAddressForSource: false,
};

const mutations = {
  [SET_CART_ARTICLES](stateData, data) {
    stateData.cartArticles = [...data];
  },
  [SET_CART_SERVICES](stateData, data) {
    stateData.cartServices = [...data];
  },
  [SET_SERVICE_CENTER](stateData, data) {
    stateData.serviceCenter = [...data];
  },
  [SET_CART_ID](stateData, data) {
    stateData.cartId = data;
  },
  [SET_SOURCE_ID](stateData, data) {
    stateData.sourceId = data;
  },
  [SET_INVOICE_ADDRESS](stateData, data) {
    stateData.invoiceAddress = { ...data };
  },
  [ADD_ARTICLE_VERSION_A](stateData, data) {
    stateData.articlesVersionA = [...stateData.articlesVersionA, data];
  },
  [UPDATE_ARTICLE_VERSION_A](stateData, data) {
    stateData.articlesVersionA = [...data];
  },
  // [SET_ALLOW_CHANGE_ADDRESS_FOR_SOURCE](stateData, data) {
  //   stateData.allowChangeAddressForSource = data;
  // },
};

const actions = {
  async getCartItems({ commit }) {
    const response = await CartService.getCart();
    if (response.status === networkStatus['ok']) {
      await commit(SET_CART_ARTICLES, response.data.cartArticles);
      await commit(SET_CART_SERVICES, response.data.services);
      commit(SET_CART_ID, response.data.id);
      // commit(SET_SOURCE_ID, response.data.addresses[0].sourceId);
    }

    return response;
  },
  async getServiceCenter({ commit }, zipcode) {
    const response = await CartService.getService(zipcode);
    if (response.status === networkStatus['ok']) {
      await commit(SET_SERVICE_CENTER, response.data);
    }

    return response;
  },
  async addCartItem(
    { _ },
    {
      articleId,
      supplierArticleTag,
      quantity,
      price,
      shortDescription,
      longDescription,
      articleGroup,
      supplier,
      ean,
      wheelsetComponents,
    },
  ) {
    const response = await CartService.addToCart({
      articleId,
      supplierArticleTag,
      quantity,
      price,
      shortDescription,
      longDescription,
      articleGroup,
      supplier,
      ean,
      wheelsetComponents,
    });

    if (response.data.status === false) {
      return Promise.reject();
    }

    return response;
  },
  async editCartItemQuantityById({ dispatch }, { positionId, quantity }) {
    await CartService.editCartQuantityById({
      positionId,
      quantity,
    });

    return dispatch('getCartItems');
  },
  async deleteCartPosition({ commit, dispatch }, id) {
    const response = await CartService.deleteCartPosition(id);
    if (response.status === networkStatus['ok']) {
      return dispatch('getCartItems');
    }
    return response;
  },
  async clearCart({ commit }) {
    const response = await CartService.clearCart();
    if (response.status === networkStatus['ok']) {
      commit(SET_CART_ARTICLES, []);
      commit(SET_CART_SERVICES, []);
    }
    return response;
  },
  async getAddress({ commit }) {
    const response = await CartService.getAddress();

    if (response.status === networkStatus['ok']) {
      commit(SET_INVOICE_ADDRESS, response.data);
    }

    return response;
  },
  async addAddress(
    { _ },
    {
      addressId,
      name,
      street,
      streetNumber,
      zip,
      country,
      countryCode,
      city,
    },
  ) {
    const response = await CartService.addAddress({
      addressId,
      name,
      street,
      streetNumber,
      zip,
      country,
      countryCode,
      city,
    });

    return response;
  },
  // async checkAllowChangeAddressForSource({ commit }, { sourceId }) {
  //   let response;
  //   try {
  //     response = await CartService.checkAllowChangeAddressForSource({ sourceId });
  //     if (response.status === 204) {
  //       commit(SET_ALLOW_CHANGE_ADDRESS_FOR_SOURCE, true);
  //     } else {
  //       commit(SET_ALLOW_CHANGE_ADDRESS_FOR_SOURCE, false);
  //     }
  //   } catch (err) {
  //     commit(SET_ALLOW_CHANGE_ADDRESS_FOR_SOURCE, false);
  //   }
  //   return response;
  // },
  async changeAddress({ _ }, { sourceId, addressId }) {
    const response = await CartService.changeAddress({
      sourceId,
      addressId,
    });
    return response;
  },
  async orderCart({ dispatch }, payload) {
    const response = await CartService.order(payload);
    if (
      response.status === networkStatus['ok'] &&
            response.data.status === false
    ) {
      return Promise.reject(response.data);
    }

    if (response.status === networkStatus['ok']) {
      return dispatch('getCartItems');
    }

    return response;
  },
  addCartArticleVersionA({ commit }, payload) {
    commit(ADD_ARTICLE_VERSION_A, payload);
    const articleVersionAData =
            JSON.parse(sessionStorage.getItem('articlesVersionA')) || [];
    sessionStorage.setItem(
      'articlesVersionA',
      JSON.stringify([...articleVersionAData, payload]),
    );
  },
  updateCartArticleVersionA({ commit }, payload) {
    commit(UPDATE_ARTICLE_VERSION_A, payload);
    sessionStorage.setItem('articlesVersionA', JSON.stringify(payload));
  },
  async clearArticleVersionA({ commit, rootState }) {
    const userId = rootState.user.userInformation.id;
    const articleVersionAData =
            JSON.parse(sessionStorage.getItem('articlesVersionA')) || [];
    const payload = articleVersionAData.filter(
      (item) => item.userId !== userId,
    );

    commit(UPDATE_ARTICLE_VERSION_A, payload);
    sessionStorage.setItem('articlesVersionA', JSON.stringify(payload));
  },
};

const getters = {
  getCartItems: (stateData, getters, rootState) => {
    // const userId = rootState.user.userInformation.id;
    let results = stateData.cartArticles;
    // const articleVersionADataSession = JSON.parse(sessionStorage.getItem('articlesVersionA')) || [];
    // const articleVersionAData = stateData.articlesVersionA.length < articleVersionADataSession.length
    //   ? articleVersionADataSession
    //   : stateData.articlesVersionA;
    // const articleVersionADataUser = articleVersionAData.filter((item) => item.userId === userId);
    // if (articleVersionADataUser) {
    //   results = [
    //     ...results,
    //     ...articleVersionADataUser,
    //   ].sort((a,b) => a.id.toString().localeCompare(b.id.toString()));
    // }
    return results;
  },
  getCartServices: (stateData) => {
    return stateData.cartServices;
  },
  getOnlyCartShipmentArticles: (stateData, getters) => {
    if (stateData.cartArticles.length === 0) {
      return [];
    }
    const filteredCartShipments = stateData.cartArticles
      .slice()
      .filter((filtered) => filtered.shipment)
      .map((item) => {
        return {
          key: `${item.shipment.type}--${item.shipment.description}`,
          ...item.shipment,
        };
      });
    return filteredCartShipments;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
